export default __webpack_public_path__ + "static/media/cytocaare-banner-02.cf8fc5bc.jpg";